export function stack(error: Error = new Error(), slice: number = 2): string[] {
    return (error.stack ?? '')
        .split('\n')
        .slice(slice)
        .map((it) => it.trim())
        .map((it) => it.replace(/^at /i, ''));
}
